import { ComposableMap, Geographies, Geography, Line, Marker } from "react-simple-maps";

const HUBS = {
  africa: { coords: [18, 2], fr: "Afrique", en: "Africa", dy: 32 },
  europe: { coords: [8, 49], fr: "Europe", en: "Europe", dy: -16 },
  asia: { coords: [98, 30], fr: "Asie", en: "Asia", dy: -16 },
};

const ARCS = [
  ["africa", "europe"],
  ["africa", "asia"],
  ["europe", "asia"],
];

const ANCHOR = {
  africa: HUBS.africa.coords,
  europe: HUBS.europe.coords,
  asia: HUBS.asia.coords,
};

export default function CorridorMap({ lang = "fr" }) {
  return (
    <div className="corridor-map relative w-full overflow-hidden border border-tertiary bg-anthracite" data-testid="corridor-map">
      <ComposableMap
        projection="geoNaturalEarth1"
        projectionConfig={{ scale: 330, center: [52, 22] }}
        width={900}
        height={480}
        style={{ width: "100%", height: "auto" }}
      >
        <Geographies geography="/world-110m.json">
          {({ geographies }) =>
            geographies.map((geo) => (
              <Geography
                key={geo.rsmKey}
                geography={geo}
                fill="#2A2A2A"
                stroke="#3A3A3A"
                strokeWidth={0.4}
                style={{ default: { outline: "none" }, hover: { outline: "none", fill: "#333" }, pressed: { outline: "none" } }}
              />
            ))
          }
        </Geographies>

        {ARCS.map(([a, b], i) => (
          <Line
            key={`${a}-${b}`}
            from={ANCHOR[a]}
            to={ANCHOR[b]}
            stroke="#C9A96E"
            strokeWidth={1.8}
            strokeLinecap="round"
            className="corridor-arc"
            style={{ animationDelay: `${i * 0.6}s` }}
          />
        ))}

        {Object.entries(HUBS).map(([key, h], i) => (
          <Marker key={key} coordinates={h.coords}>
            <circle r={18} fill="#C9A96E" opacity={0.15} className="corridor-pulse" style={{ animationDelay: `${i * 0.5}s` }} />
            <circle r={5.5} fill="#C9A96E" />
            <circle r={2} fill="#FCFBF9" />
            <text
              textAnchor="middle"
              y={h.dy}
              style={{ fontFamily: "Georgia, 'Times New Roman', serif", fontSize: 18, fill: "#FCFBF9", letterSpacing: 1 }}
              data-testid={`corridor-map-label-${key}`}
            >
              {lang === "fr" ? h.fr : h.en}
            </text>
          </Marker>
        ))}
      </ComposableMap>
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_center,transparent_65%,rgba(31,31,31,0.6)_100%)]" />
    </div>
  );
}
